import React from 'react'

export default function Error() {
    return (
        <div>
            <h1><strong>This page cannot be found.</strong></h1>
        </div>
    )
}
